/**
 * Coupure automatique du live : quand la durée incluse dans le forfait est écoulée, le back clôt la
 * session et publie l'événement ci-dessous sur le canal Ably. L'avertissement qui précède la coupure
 * n'est pas traité ici : le bandeau de fin de session le couvre déjà, à partir de `startedAt` et des
 * limites du forfait.
 */
export function isSessionDurationExceeded(messageName: string | undefined, data: unknown): boolean {
  if (messageName !== 'event-message' || !data || typeof data !== 'object') {
    return false;
  }
  return (data as { type?: unknown }).type === 'SESSION_DURATION_EXCEEDED';
}
